import AccountDetailsContainer from 'redux/containers/components/account/AccountDetailsContainer'
import History from 'components/account/History'
import Preferences from 'components/account/Preferences'
import {
  ACCOUNT_DETAILS as _ACCOUNT_DETAILS,
  ACCOUNT_HISTORY as _ACCOUNT_HISTORY,
  ACCOUNT_PREFERENCES as _ACCOUNT_PREFERENCES
} from 'constants/feature-flags'

export const ACCOUNT_MENU = {
  details: {
    component: AccountDetailsContainer,
    label: 'User details',
    visible: _ACCOUNT_DETAILS
  },
  history: {
    component: History,
    label: 'Search history',
    visible: _ACCOUNT_HISTORY
  },
  preferences: {
    component: Preferences,
    label: 'My preferences',
    visible: _ACCOUNT_PREFERENCES
  }
}

const returnWithKey = (key) => ({
  view: key,
  ...ACCOUNT_MENU[key]
})

export const ACCOUNT_DETAILS = returnWithKey('details')
export const ACCOUNT_HISTORY = returnWithKey('history')
export const ACCOUNT_PREFERENCES = returnWithKey('preferences')
